/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import Flex from "@atg/icf-react-components/components/Flex";
import RaisedButton from "@atg/icf-react-components/components/RaisedButton";
import SvgIcon from "@atg/icf-react-components/components/SvgIcon";
import Text from "@atg/icf-react-components/components/Text";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { RequestStatus } from "~/constants";
import { selectTwoFactorAuthEmailStatus } from "~/features/auth/selectors";
import { send2FAEmail } from "~/features/auth/thunks";
import { AppDispatch } from "~/state/types";

const TwoFactorAuthRequired: FC = () => {
  const { t } = useTranslation("auth");
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const emailStatus = useSelector(selectTwoFactorAuthEmailStatus);

  const onClick = async () => {
    const returnUrl = location.pathname;
    await dispatch(send2FAEmail({ returnUrl: returnUrl }));
  };

  return (
    <Flex gap="20" alignItems="center" margin="16 0 60 0">
      <SvgIcon name="lock" fill="primaryDark" size="large" style={{ width: "105", height: "105" }} />
      <Text textAlign="center" variant="body_l" width="80%">
        {emailStatus === RequestStatus.ERROR
          ? t("error.unknown_error", { ns: "common" })
          : t("two_factor_auth.modal.text.default")}
      </Text>
      <RaisedButton
        type="button"
        disabled={[RequestStatus.SUCCESS, RequestStatus.PENDING].includes(emailStatus)}
        label={t("two_factor_auth.modal.button.verify_email")}
        onClick={onClick}
        width={256}
      />
    </Flex>
  );
};

export default TwoFactorAuthRequired;
